import { render, staticRenderFns } from "./FaturaDespesaDetalhes.vue?vue&type=template&id=5281e49b"
import script from "./FaturaDespesaDetalhes.vue?vue&type=script&lang=js"
export * from "./FaturaDespesaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports